import { Component, Input, Output, EventEmitter, OnInit, inject } from '@angular/core';
import { InspectionResultFieldValueDto } from '../core/api/model/inspectionResultFieldValueDto';
import { InspectionResultPointDto } from '../dtos/inspectionResultPointDto';
import { InspectionElementFieldType } from '../core/api/model/inspectionElementFieldType';
import { I18nTextPipe } from '../core/pipes/i18n-text.pipe';
import { DetailResultButtonComponent } from './detail-result-button.component';
import { FormsModule } from '@angular/forms';
import { FormControlComponent } from '../form/form-control.component';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { DisableDirective } from '../form/disabled.rective';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MkdeDatepickerComponent } from '../datepicker/mkde-datepicker.component';

@Component({
  selector: 'app-detail-list-point',
  templateUrl: './detail-list-point.component.html',
  styleUrls: ['./detail.component.scss', 'detail-list.component.scss'],
  imports: [
    DetailResultButtonComponent,
    FormsModule,
    FormControlComponent,
    NgbPopover,
    DisableDirective,
    TranslateDirective,
    MkdeDatepickerComponent,
    TranslatePipe,
  ],
})
export class DetailListPointComponent implements OnInit {
  private i18nTextPipe = inject(I18nTextPipe);

  @Input()
  public point!: InspectionResultPointDto;

  @Input()
  public readonly = false;

  @Input()
  public displayCopyFieldValueNumber = false;

  @Output()
  public resultChange: EventEmitter<any> = new EventEmitter();

  @Output()
  public copyValue: EventEmitter<any> = new EventEmitter();

  public fieldTypes = InspectionElementFieldType;

  private previousFieldValue!: InspectionResultFieldValueDto;

  public onPointResultChanged(): void {
    this.resultChange.emit();
  }

  public onCopyFieldValueNumber(): void {
    this.copyValue.emit();
  }

  public onPointFieldValueChanged(): void {
    let hasFieldValueChanged = false;
    const newPointResult = this.point.pointResult?.fieldValue;
    this.point.previousFieldValue = Object.assign({}, this.previousFieldValue);
    if (!newPointResult) {
      return;
    }
    switch (newPointResult.inspectionElementFieldType) {
      case 'date':
        if (newPointResult.dateValue !== this.previousFieldValue.dateValue) {
          hasFieldValueChanged = true;
          this.previousFieldValue.dateValue = newPointResult.dateValue;
        }
        break;
      case 'number':
        if (newPointResult.numberValue !== this.previousFieldValue.numberValue) {
          hasFieldValueChanged = true;
          this.previousFieldValue.numberValue = newPointResult.numberValue;
        }
        break;
      case 'text':
        if (newPointResult.textValue !== this.previousFieldValue.textValue) {
          hasFieldValueChanged = true;
          this.previousFieldValue.textValue = newPointResult.textValue;
        }
        break;
      case 'yesNo':
        if (newPointResult.yesNoValue !== this.previousFieldValue.yesNoValue) {
          hasFieldValueChanged = true;
          this.previousFieldValue.yesNoValue = newPointResult.yesNoValue;
        }
        break;
    }

    if (hasFieldValueChanged) {
      this.resultChange.emit();
    }
  }

  public ngOnInit(): void {
    if (this.point.pointResult?.fieldValue) {
      const fieldValue = this.point.pointResult.fieldValue;
      this.previousFieldValue = {
        dateValue: fieldValue.dateValue,
        inspectionElementFieldType: fieldValue.inspectionElementFieldType,
        numberValue: fieldValue.numberValue,
        textValue: fieldValue.textValue,
        yesNoValue: fieldValue.yesNoValue,
      };
    }
  }

  public isTextFieldValueSuggestionEmpty(): boolean {
    return (
      this.point.textFieldValueSuggestions === null ||
      this.point.textFieldValueSuggestions === undefined ||
      this.point.textFieldValueSuggestions.length <= 0
    );
  }

  public getTextFieldValueSuggestions(suggestion: string): string[] {
    const suggestions = this.point.textFieldValueSuggestions
      ?.filter(Boolean)
      .map((suggestionTranslation) => this.i18nTextPipe.transform(suggestionTranslation))
      .filter(Boolean) as string[];
    return suggestions.includes(suggestion) ? suggestions : [suggestion, ...suggestions];
  }

  public insertTextFieldValueSuggestion(suggestion: string): void {
    if (!this.point.pointResult?.fieldValue) {
      return;
    }
    if (!this.point.isTextReadonly) {
      const value = this.point.pointResult.fieldValue.textValue
        ? this.point.pointResult.fieldValue.textValue + ', '
        : '';
      this.point.pointResult.fieldValue.textValue = `${value}${suggestion}`;
    } else {
      this.point.pointResult.fieldValue.textValue = suggestion;
    }
  }
}
